import React, {useState} from "react";
import {AiOutlineClose} from "react-icons/ai";
import {GrCart} from 'react-icons/gr';

const Detail=({item,setModal,quan,setQuan,setCartItem,cartItem})=>{
    const [name,setName]=useState(item.name);
    const handleChange=(i)=>{
        setName(item.name+"::"+i);
    }
    return(
        <div className={'detail-container flex__column'}>
            <div className={'manager-modal-close-box'}>
                <AiOutlineClose size={20} style={{cursor:'pointer'}} onClick={()=>setModal(false)}/>
            </div>
            <div className={'scroll-auto'}>
                <div className={'flex__center'}>
                    <div className={'flex__low detail-modal-item'}>
                        <img src={item.url} alt={'img'} width={300} height={300}/>
                        <div className={'flex__column detail-modal-title'}>
                            <span><b>상품명:</b> {item.name}</span>
                            <span><b>가격:</b> {item.price} 원</span>
                            {
                                item.option.length>0&&
                                <div className={'detail-option-box'}>
                                    <span>옵션:</span>
                                    <select onChange={e=>handleChange(e.target.value)} defaultValue={'1'} >
                                        <option value={'1'}>옵션선택</option>
                                        {
                                            item.option.map((i)=>(
                                                <option value={i.value} key={i.value}>{i.value}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            }
                            <div className={'flex__low detail-option-box'}>
                                <span>수량:</span>
                                <input
                                    type={'number'}
                                    min={'1'}
                                    max={'99'}
                                    value={quan}
                                    onChange={(e)=>setQuan(e.target.value)}
                                    className={'quan-input'}
                                />
                            </div>
                            <div className={'item-button flex__center'} onClick={()=>{
                                setCartItem([...cartItem,{id: Date.now(),name: name, price: item.price, quan:quan}]);
                                setQuan(1)
                            }}>
                                <a>카트담기</a><GrCart size={20}/>
                            </div>
                        </div>
                    </div>
                    <div className={'flex__center detail-explan-box'}>
                        <pre>
                            {item.explan}
                        </pre>
                    </div>
                    <img src={item.suburl} alt={'img'} width={'100%'}/>
                    <div className={'grey-button flex__center'} onClick={()=>{setModal(false)}}>
                        닫기
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Detail
